import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import ViewModal from './View';
import AddAdmins from "./Add";
import useLiveDataTable from "../../hooks/useLiveDataTable";
import PageHeader from "../../components/PageHeader";
import CustomPagination from "../../components/CustomPagination";
import { deleteConfirmation, loadingConfirmation } from "../../utils";
import { useGetDispatchersQuery, useRemoveDispatcherMutation } from '../../redux/services/DispatcherService';


const AdminsPage = () => {
    const navigate = useNavigate()
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();

    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)

    const [removeRequest] = useRemoveDispatcherMutation()
    // const [statusRequest] = useChangeStatusCompanyMutation()

    const { data: data2, isFetching, refetch } = useGetDispatchersQuery({
        id: 'admins',
        pagination: `?page=${currentPage}&per_page=${perPage}&search_by=${searchBy}&search=${q}`
    })
    const admins = data2?.response?.data?.data
    const total = data2?.response?.data?.total;


    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }

    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }

    // const data = [];

    return (
        <>
            <PageHeader name="Admins" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0">
                                    <div className="col-auto p-0 d-flex">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={handleAdd}
                                        >
                                            Add Admin
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 d-flex ms-2">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={refetch}
                                        >
                                            Refresh
                                        </Button>
                                    </div>
                                    {/*<div className="col-auto ms-auto">
                                        <button className="btn bg-light text-capitalize">
                                            Search By: <span className='text-success'>{searchBy?.split('_')?.join(' ')?.replace('full name', 'driver name')}</span>
                                        </button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                                value={searchQuery}
                                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                                onChange={(e) => setSearchQuery(e.target?.value)}
                                            />
                                            <span
                                                type="button"
                                                onClick={() => handleSearchChange(searchQuery)}
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                        </div>
                                    </div>*/}
                                </div>
                            </div>
                            <div className="card-body">
                                <CustomPagination
                                    isFetching={isFetching}
                                    data={admins}
                                    total={10}
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page

                                    columns={[
                                        {
                                            selector: row => row.first_name,
                                            sortable: true,
                                            width: '160px',
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('first_name')}
                                                >
                                                    {searchBy == 'first_name' ? <b className='text-success'>First
                                                        Name</b> : 'First Name'}
                                                </span>
                                            ),
                                        },
                                        {
                                            selector: row => row.last_name,
                                            sortable: true,
                                            width: '160px',
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('last_name')}
                                                >
                                                    {searchBy == 'last_name' ? <b className='text-success'>User First
                                                        Name</b> : 'Last Name'}
                                                </span>
                                            ),
                                        },
                                        {
                                            selector: row => row.email,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('email')}
                                                >
                                                    {searchBy == 'email' ?
                                                        <b className='text-success'>Email</b> : 'Email'}
                                                </span>
                                            ),
                                            width: '160px'
                                        },
                                        {
                                            selector: row => row.phone,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('phone')}
                                                >
                                                    {searchBy == 'phone' ?
                                                        <b className='text-success'>Phone</b> : 'Phone'}
                                                </span>
                                            ),
                                        },
                                        {
                                            name: 'Status',
                                            cell: (row) => (
                                                <div className="form-switch">
                                                    {/* {row?.is_application_editable} */}
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        defaultChecked={row.status == 0 ? false : true}
                                                        readOnly
                                                    // onClick={() => loadingConfirmation(() => statusRequest({
                                                    //     id: row?.id,
                                                    //     status: row?.status == 0 ? 1 : 0
                                                    // }), 'Chnage Status', row?.status == 0 ? 1 : 0)}
                                                    />
                                                </div>
                                            ),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Actions',
                                            cell: (row, i) => {
                                                return (
                                                    <div className="hstack gap-1 fs-1">

                                                        <a
                                                            aria-label="view"
                                                            onClick={handleView.bind(this, row)}
                                                            className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-eye-fill" />
                                                        </a>
                                                        <button
                                                            aria-label="edit"
                                                            onClick={handleEdit.bind(this, row)}
                                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-edit-line" />
                                                        </button>
                                                        <a
                                                            aria-label="delete"
                                                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-delete-bin-7-line" />
                                                        </a>
                                                    </div>
                                                )
                                            },
                                            ignoreRowClick: true,
                                            allowOverflow: true,
                                            button: true,
                                            width: '150px'
                                        },
                                    ]}

                                />
                            </div>
                        </div>

                        {isShow && (
                            <AddAdmins
                                type={1} // Admins Account Type is 1
                                show={isShow}
                                handleClose={() => {
                                    setIsShow(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}

                        {isView && (
                            <ViewModal
                                show={isView}
                                handleClose={() => {
                                    setIsView(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminsPage;